export default __webpack_public_path__ + "static/google-7d95cccac8450ff9bf6f53043cf8fcd2.jpg";